import { NgRedux } from '@angular-redux/store';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SearchFieldComponent } from '../shared-layout/Components/search-field/search-field.component';
import { NotificationService } from '../shared/errors/notification.service';
import {
  IAppState,
  IFilterFloor,
} from '../shared/state-management/state-interfaces';
import { CommonService } from '../shared/utils/common.service';
import { FilterFloorsComponent } from './filter-floors/filter-floors.component';
import { Floor, IFloor } from './floor-management-interface';
import { LocalizationService } from '../shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-floor-management',
  templateUrl: './floor-management.component.html',
  styleUrls: ['./floor-management.component.scss'],
})
export class FloorManagementComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  readonly LANG_CONST = LANG_CONST;
  isListAvailable!: boolean | true;
  sharedData: any;
  subscription: Subscription | undefined;
  floorManagementSubscription: Subscription | undefined;
  CONSTANTS = CONSTANTS;
  selectedbuildingId!: string; //for local variable reason: back to back server hit
  @Input() selectedBuilding: any;
  filter!: IFilterFloor;
  filterCount: number = 0;
  searchUnit!: string;
  appFloors!: Floor;
  floors!: Floor;
  isDisabledClickUnitAndAccessPoint = false; // disabled click event util data load of unit / accesspoint
  isNestedCallActive: boolean = false;
  isUnitAndAccessPointFetch: boolean[] = [];
  isUnitAndAccessPointLoaded: boolean = false;
  commonAccessControl!: boolean;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  scrollDown = new EventEmitter<any>();
  private numberOfItems = 10;

  @ViewChild(SearchFieldComponent) searchFieldComponentRefComp:
    | SearchFieldComponent
    | undefined;
  siteId: any;
  buildingId: any;
  unitAndAccessPointSubscription: Subscription | undefined;

  constructor(
    private floorManagementService: FloorManagementService,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private ngRedux: NgRedux<IAppState>,
    private changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.sharedDataService.currentData.subscribe((sharedData: any) => {
      this.sharedData = sharedData;
      if (
        (this.sharedData.selectedSite.siteId &&
          this.siteId != this.sharedData.selectedSite.siteId) ||
        (this.sharedData.selectedBuilding.buildingId &&
          this.buildingId != this.sharedData.selectedBuilding.buildingId)
      ) {
        this.siteId = this.sharedData.selectedSite.siteId;
        this.buildingId = this.sharedData.selectedBuilding.buildingId;
        this.commonAccessControl =
          this.sharedData.selectedSite.commonAccessControl;
      }
    });

    this.ngRedux.select('appData').subscribe((res: any) => {
      if (JSON.stringify(this.appFloors) !== JSON.stringify(res?.floors)) {
        this.floors = res?.floors ? [...res?.floors] : [];
        this.appFloors = this.floors;
        this.getUnitAndAccessPoint(this.siteId, this.buildingId, this.floors);
      }
      this.changeDetectorRef.detectChanges();
    });
    this.searchFieldComponentRefComp?.clear();
    this.floorManagementSubscription =
      this.floorManagementService?.triggerRerender?.subscribe(
        (result: boolean) => {
          if (result) {
            const siteId = this.sharedData?.selectedSite?.siteId;
            const buildingId = this.sharedData?.selectedBuilding?.buildingId;
            this.getFloorBySiteBuildingId(siteId, buildingId);
            this.floorManagementService.setTriggerRerender(false);
          }
        }
      );
    this.fetchUnitsAndAccessPoints();

    this.unitAndAccessPointSubscription =
      this.commonService.isLoadingUnitAndAccessPointSubject.subscribe(
        (status: boolean) => {
          this.isDisabledClickUnitAndAccessPoint = status;
        }
      );
  }

  /**
   * @description initialize the scroll with style
   * @returns void
   */
  ngAfterViewInit() {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.style.maxHeight = '530px';
      this.scrollContainer.nativeElement.style.overflow = 'auto';
    }
  }

  /**
   * @description this function responsible of fetch new floors data on scroll down
   * @param ev event of scroll
   * @returns void
   */
  onScrollDown(ev: any) {
    this.scrollDown.emit(ev);
  }

  /**
   * @description #initializeFilter function gets the floorList from app and
   *               map the data int the required state of filter component.
   * @returns void
   */

  initializeFilter() {
    this.filter = {
      floors: this.floors,
      wings: [],
      floorsSelected: [],
      wingsSelected: [],
      filterType: CONSTANTS.FLOOR_MANAGEMENT,
    };
    this.filter.floors = this.appFloors?.map((floor: IFloor) => {
      return {
        ...floor,
        floorState: CONSTANTS.NOT_SELECTED,
        wingState: CONSTANTS.NOT_SELECTED,
      };
    });
    //null and empty value is handle here
    let emptyValueAppended = false;
    let uniqueWings: any = this.filter.floors
      ?.map((floor: IFloor) => floor?.wingName)
      .filter((value, index, self) => {
        if (!emptyValueAppended && (value === '' || value === null)) {
          emptyValueAppended = true;
          return true;
        }
        return value && self.indexOf(value) === index;
      });

    for (let i = 0; i < uniqueWings?.length; i++) {
      this.filter.wings.push({
        wingName: uniqueWings[i],
        wingState: CONSTANTS.NOT_SELECTED,
      });
    }
  }

  /**
   * @description #fetchUnitsAndAccessPoints function calls getAllFloorsByBuildingId
   *              and merge data of relevant units for each floor by calling
   *              getUnitsAndAccessPointsByFloor API.
   * @returns void
   */
  fetchUnitsAndAccessPoints(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        const siteId = this.sharedData?.selectedSite?.siteId;
        const buildingId = this.sharedData?.selectedBuilding?.buildingId;
        if (
          buildingId &&
          this.selectedBuilding &&
          this.selectedbuildingId !== buildingId
        ) {
          this.selectedbuildingId = buildingId;
          this.getFloorBySiteBuildingId(siteId, buildingId);
        }
      }
    );
  }

  /**
   * @description: runs just before component unmount. empty the object of activities.
   * @input {none}
   * @output {void}
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.floorManagementSubscription?.unsubscribe();
    this.unitAndAccessPointSubscription?.unsubscribe();
  }

  /**
   * @description: onFilterUnit function function opens the modal poup for Edit unit.
   * @input none
   * @output { void }
   */

  onFilterUnit() {
    const dialogRef = this.helperService.openModalDialog(
      FilterFloorsComponent,
      this.filter,
      [CONSTANTS.FIXED_SCREEN_MODAL]
    );

    dialogRef?.afterClosed().subscribe((filterFloors: IFilterFloor) => {
      if (filterFloors) {
        this.sharedDataService.setSelectedUnit({
          unitName: null,
          unitId: null,
        });
        this.filter = filterFloors;
      } else return;

      this.filterCount =
        this.filter?.floorsSelected.length + this.filter?.wingsSelected.length;
      if (this.filterCount > 0) {
        this.floors = this.filter.floors?.filter((floor: IFloor) => {
          if (
            this.filter?.floorsSelected.length > 0 &&
            this.filter?.wingsSelected.length > 0
          ) {
            return (
              floor.floorState === CONSTANTS.SELECTED &&
              floor.wingState === CONSTANTS.SELECTED
            );
          } else if (
            this.filter?.floorsSelected.length > 0 &&
            this.filter?.wingsSelected.length === 0
          ) {
            return floor.floorState === CONSTANTS.SELECTED;
          } else if (
            this.filter?.wingsSelected.length > 0 &&
            this.filter?.floorsSelected.length === 0
          ) {
            return floor.wingState === CONSTANTS.SELECTED;
          }
        });
      } else {
        this.floors = this.appFloors;
      }
    });
  }

  getFloorBySiteBuildingId(siteId: string, buildingId: string) {
    this.isNestedCallActive = true;
    this.floorManagementService
      .getAllFloorsByBuildingId(siteId, buildingId, true)
      .subscribe({
        next: (res: any) => {
          this.isNestedCallActive = false;
          this.isListAvailable = true;
          this.filterCount = 0;
          this.commonService.setLoadingBuilding(false);
        },
        error: (err: Error) => {
          this.commonService.setLoadingBuilding(false);
          if (
            err.message != this.translate.instant('NO_FLOORS_IN_THIS_BUILDING)')
          ) {
            this.notificationService.showError(err?.message);
          }
          this.isListAvailable = false;
          this.isNestedCallActive = false;
        },
      });
  }

  /**
   * Retrieves units and access points given floors ID.
   * @param siteId The ID of the site.
   * @param buildingId The ID of the building.
   * @param floors An array of floor objects.
   */
  getUnitAndAccessPoint(siteId: string, buildingId: string, floors: Floor) {
    for (let i = 0; i < floors!.length; i++) {
      this.isUnitAndAccessPointFetch[i] = true;
      const floor = floors![i];
      this.floorManagementService
        .getUnitsAndAccessPointsByFloor(
          siteId,
          buildingId,
          floor?.floorId,
          true
        )
        .subscribe(
          (res) => {
            this.isUnitAndAccessPointFetch[i] = false; // Set the flag to false when the API call is completed
            this.isUnitAndAccessPointLoaded = true;
            if (res) this.initializeFilter();
          },
          (error) => {
            console.error('Error retrieving units for floor', error);
            this.isUnitAndAccessPointFetch[i] = false; // Set the flag to false in case of an error
            this.isUnitAndAccessPointLoaded = true;
          }
        );
    }
  }

  /**
   * @param ev selected value
   * @description search any keyword
   * @returns void
   */
  searchUnitsEvent(ev: string): void {
    this.searchUnit = ev;
  }

  /**
   * @param index The index of the current option in the ngFor loop.
   * @param option  The current option object in the ngFor loop.
   * @returns  The option itself as the unique identifier for tracking.
   */
  trackByOption(index: number, option: any) {
    return option?.floorId || index;
  }
}
